const LoadComp = () => {
    return <div className="v-100 w-100 d-flex justify-content-center align-items-center">
        {/* <div ref={anime} style={{ height: 250, width: 300 }}>
                    </div> */}
        {/* <LoadingComp /> */}
        <div className="ripple">
            <span className="ripple-inner"></span>
            <span className="ripple-inner-2"></span>
            <span className="ripple-inner-3"></span>
            <img alt="logo" src="/assets/svg/ebs-logo_1.svg" />
        </div>
    </div>
}
export default LoadComp